export enum Currency {
  USD = 1,
  AUD = 2
}

export enum OrderStatusDisplayName {
  submit = 'open',
  partialFill = 'partially filled',
  cancel = 'killed',
  fill = 'filled'
}

export enum FeeTransferDirection {
  withdrawal = -1,
  deposit= 1
}

export const TimeFormat = 'YYYY-MM-DDTHH:mm:ss.SSSZ'



// WEBPACK FOOTER //
// ./ts/enums.ts